import type { GetServerSideProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import { ContactPage } from '@/components/pages/ContactPage';
import { ContactPageSP } from '@/components/pages/ContactPageSP';
import { Meta } from '@/layouts/Meta';
import { Main } from '@/templates/Main';
const Index = () => {
  return (
    <Main
      meta={
        <Meta
          title="お問い合わせフォーム（入力画面）｜税理士法人奏共同会計事務所"
          description="税理士法人奏共同会計事務所は、資本戦略の実行支援を専門とする日本唯一の税理士法人です。組織再編、事業承継、M&A、国際資本戦略など、企業の成長ステージに応じた先進的なソリューションを提供。高い職業倫理と専門性を持つプロフェッショナル集団として、お客様の経営課題解決を支援します。"
        />
      }
      desktop={<ContactPage />}
      mobile={<ContactPageSP />}
    />
  );
};

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale!, ['common', 'contact'])),
    },
  };
};

export default Index;
